module.exports = __webpack_public_path__ + "img/sy_banner.9a295ded.png";